import { useState } from 'react'

export function useEmailJS() {
  const [status, setStatus] = useState('idle') // idle | sending | success | error

  async function send(templateParams) {
    setStatus('sending')

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: templateParams.from_name,
          phone: templateParams.phone,
          email: templateParams.email,
          serviceType: templateParams.service_type,
          contactMethod: templateParams.contact_method,
          message: templateParams.message,
          _honeypot: templateParams.website,
        }),
      })

      if (res.ok) {
        setStatus('success')
        return { success: true }
      } else {
        setStatus('error')
        return { success: false }
      }
    } catch {
      setStatus('error')
      return { success: false }
    }
  }

  function reset() {
    setStatus('idle')
  }

  return { send, status, reset }
}
